import React, { FunctionComponent } from 'react';
import { SelectSingleComponent } from '../../Select';
import { Answers, SelectField, SelectFieldSchema, SelectValue, SelectValueSchema } from '../dynamicFormSchema';
import { DynamicFieldProps } from '../DynamicField';
import { TypeConverterName, typeConverters } from '../typeConverters';
import { DynamicFieldComponent } from './DynamicFieldComponentBase';

export const SelectFieldComponent: FunctionComponent<DynamicFieldProps> = ({ field, reactHookField, onChange }) => {
  const r = SelectFieldSchema.parse(field);

  return (
    <SelectSingleComponent
      label={r.label}
      name={r.name}
      description={r.description}
      options={r.options}
      value={reactHookField.value}
      onChange={onChange}
      disabled={reactHookField.disabled}
    />
  );
};

export class DynamicSelectField extends DynamicFieldComponent<SelectField, SelectValue> {
  Component = SelectFieldComponent;

  constructor(field: SelectField) {
    super(field);
  }

  getAnswer(answers: Answers): SelectValue {
    const answer = answers[this.field.name];
    if (answer === undefined) {
      return this.getDefaultValue();
    }

    if (SelectValueSchema.safeParse(answer).success) {
      return answer as SelectValue;
    }

    throw new Error(`Invalid answer for field ${this.field.name}`);
  }

  getDefaultValue(): SelectValue {
    return this.field.defaultValue || '';
  }

  getValueToSubmit(value: SelectValue): SelectValue {
    const converter = typeConverters[this.field.fieldType as TypeConverterName];
    return converter(value);
  }
}
